import { SiApplepay, SiVisa, SiMastercard, SiPaypal } from "react-icons/si";

export const paymentMethods = [
  { id: "applepay", label: "Apple Pay", Icon: SiApplepay },
  { id: "visa", label: "Visa", Icon: SiVisa },
  { id: "mastercard", label: "Mastercard", Icon: SiMastercard },
  { id: "paypal", label: "PayPal", Icon: SiPaypal },
];

export default function PaymentMethods({ compact = false, className = "" }) {
  return (
    <div data-testid="payment-methods" className={className}>
      {!compact && (
        <div className="flex items-center gap-3 mb-4">
          <span className="w-8 h-px bg-accent" />
          <span className="font-body text-[10px] uppercase tracking-[0.35em] text-accent">
            Metodi di pagamento accettati
          </span>
        </div>
      )}
      <div className={`flex flex-wrap ${compact ? "gap-2" : "gap-3"}`}>
        {paymentMethods.map(({ id, label, Icon }) => (
          <div
            key={id}
            data-testid={`payment-${id}`}
            className={`group flex items-center gap-3 border border-white/15 bg-white/[0.03] hover:border-accent/40 transition-colors ${
              compact ? "px-3 py-2" : "px-4 py-3"
            }`}
            aria-label={label}
          >
            <Icon
              size={compact ? 22 : 30}
              className="text-white/90 group-hover:text-white transition-colors"
            />
            <span className="font-body text-[10px] uppercase tracking-[0.25em] text-white/60 group-hover:text-white/85 transition-colors">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
